let CalculatorButton = () => {
    return(
        <>
            <a href="https://664b18067c57ca88d6ac968b--courageous-faun-d5a974.netlify.app/">
            <button style={{backgroundColor: "black", color: "yellow", marginLeft: "20px", marginTop: "20px", scale: "1", borderRadius: "10px", paddingLeft: "10px", paddingRight: "10px"}}>Investment Calculator</button>
            </a>
        </>
    )
}

export default CalculatorButton;